import styled from 'styled-components';
import { FONT_FAMILY_MAIN } from '../../theme';

export const HelpText = styled.div`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 10px;
  line-height: 1.2;
  letter-spacing: 0.1px;
  text-align: ${(props) => props.align};
  color: #979ea7;
  margin-top: 8px;
`;
